import * as Msal from "msal";

export interface MsalOptions {
    instance: string;
    clientId: string;
    tenantId: string;
    redirectUri: string;
}

export let msalInstance: Msal.UserAgentApplication;

export const init = (opt: MsalOptions) => {
    const msalConfig: Msal.Configuration = {
        auth: {
            clientId: opt.clientId,
            authority: `${opt.instance}${opt.tenantId}`,
            redirectUri: opt.redirectUri,
        },
    };

    msalInstance = new Msal.UserAgentApplication(msalConfig);
};

export const roles = {
    MessengerAdmin: "Messenger.Admin",
};
